import { Role } from "components/WithRoleAuthorization/WithRoleAuthorization"

/**
 * Interface para redux action
 */
export interface IAuthenticationAction {
    type: string
    payload: any
}
/**
 * Interface para representar retorno da busca de usuario na Microsoft GraphAPI
 */
export interface IUserDataContext {
    businessPhones: []
    displayName: string
    givenName: string
    jobTitle: string
    mail: string
    mobilePhone: any
    officeLocation: string
    preferredLanguage: any
    surname: string
    userPrincipalName: string
    id: string
}

export type UserDataContext = IUserDataContext

export interface IDataUsersDataContext {
    value: UserDataContext[]
}

export type DataUsersDataContext = IDataUsersDataContext

export interface IDataUserDataContext {
    value: UserDataContext
}

export type DataUserDataContext = IDataUserDataContext

/**
 * Interface para objeto reducer
 */
export type UserLocations = {
    sys_id?: string,
    name?:string,
    sectors: [{ name: string, sys_id: string }], 
    value: string
}
export type UserDataType = {
    u_user_id: string
    name: string
    mail: string
    profile: Role
    sys_id: string
    sys_user?: string
    tokenJwt: string
    location?: string
    sector?: {
        label: string
        value: string
    }
    locations?: UserLocations[]
}
export interface IAuthenticationReducer {
    dataGraph: UserDataContext[]
    dataJwt: UserDataType
    dataAzure: any
    loading: boolean
    error: boolean
    azureAccessTokenExpired: boolean
    isAutheticated: boolean
    jwtAccessTokenExpired: boolean
    showHeader: boolean
    messageAuthentication: any
}

export type AuthenticationAction = IAuthenticationAction
/**
 * Tipo para reducer
 */
export type AuthenticationReducer = IAuthenticationReducer

/**
 * Objeto padrão
 */
export const AuthenticationReducerTypeInitiator: IAuthenticationReducer = {
    dataJwt: null,
    dataAzure: null,
    dataGraph: null,
    loading: true,
    error: false,
    azureAccessTokenExpired:false,
    jwtAccessTokenExpired:false,
    isAutheticated:false,
    showHeader:true,
    messageAuthentication: null
}

/**
 * Objeto padrão
 */
export const UserDataContextTypeInitiator: IUserDataContext = {
    businessPhones: [],
    displayName: '',
    givenName: '',
    jobTitle: '',
    mail: '',
    mobilePhone: '',
    officeLocation: '',
    preferredLanguage: '',
    surname: '',
    userPrincipalName: '',
    id: ''
}
